import { useEffect, useState } from 'react';

export const useOnVisibleDocument = (): boolean => {
	const [isVisible, setisVisible] = useState(true);
	useEffect(() => {
		const onBlurFn = (): void => {
			setisVisible(false);
		};
		const onFocusFn = (): void => {
			setisVisible(true);
		};
		window.addEventListener('blur', onBlurFn);
		window.addEventListener('focus', onFocusFn);
		return (): void => {
			window.removeEventListener('blur', onBlurFn);
			window.removeEventListener('focus', onFocusFn);
		};
	}, []);
	return isVisible;
};
